import { LocationDto } from '@lib-ui/client';

export function filterLocationSelect(searchTerm: string, location: LocationDto) {
  const termLower = searchTerm.toLowerCase();
  const address = `${location.street}+${location.houseNumber},${location.postalCode}+${location.city}`.toLowerCase();
  const identifier = location.identifier?.toLowerCase() ?? '';
  return address.includes(termLower) || identifier.includes(termLower);
}
